export const YELLOW_COMPONENTS = {
  // Week 1 Components - Grammar
  "yellow/week1/grammar/AdjectivesContent": () =>
    import("../yellow/week1/grammar/AdjectivesContent"),
  "yellow/week1/grammar/MakeDoContent": () =>
    import("../yellow/week1/grammar/MakeDoContent"),
  "yellow/week1/grammar/PartsOfSpeechContent": () =>
    import("../yellow/week1/grammar/PartsOfSpeechContent"),

  // Week 1 Components - Listening
  "yellow/week1/listening/DescribingPlacesContent": () =>
    import("../yellow/week1/listening/DescribingPlacesContent"),
  "yellow/week1/listening/ListeningVocabularyContent": () =>
    import("../yellow/week1/listening/ListeningVocabularyContent"),

  // Week 1 Components - Reading
  "yellow/week1/reading/MainIdeasContent": () =>
    import("../yellow/week1/reading/MainIdeasContent"),
  "yellow/week1/reading/ReadingVocabularyContent": () =>
    import("../yellow/week1/reading/ReadingVocabularyContent"),
  "yellow/week1/reading/ScanningContent": () =>
    import("../yellow/week1/reading/ScanningContent"),
  "yellow/week1/reading/SkimmingContent": () =>
    import("../yellow/week1/reading/SkimmingContent"),

  // Week 1 Components - Review
  "yellow/week1/review/Week1ReviewContent": () =>
    import("../yellow/week1/review/Week1ReviewContent"),

  // Week 1 Components - Speaking
  "yellow/week1/speaking/DescribingPeopleContent": () =>
    import("../yellow/week1/speaking/DescribingPeopleContent"),
  "yellow/week1/speaking/DescribingPlacesSpeakingContent": () =>
    import("../yellow/week1/speaking/DescribingPlacesSpeakingContent"),
  "yellow/week1/speaking/DescribingThingsContent": () =>
    import("../yellow/week1/speaking/DescribingThingsContent"),
  "yellow/week1/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week1/speaking/SpeakingVocabularyContent"),

  // Week 1 Components - Vocabulary
  "yellow/week1/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week1/vocabulary/AcademicWordsContent"),

  // Week 1 Components - Writing
  "yellow/week1/writing/FormattingBasicsContent": () =>
    import("../yellow/week1/writing/FormattingBasicsContent"),
  "yellow/week1/writing/SimpleSentencesContent": () =>
    import("../yellow/week1/writing/SimpleSentencesContent"),

  // Week 2 Components - Grammar
  "yellow/week2/grammar/PastSimpleContent": () =>
    import("../yellow/week2/grammar/PastSimpleContent"),
  "yellow/week2/grammar/PresentSimpleContent": () =>
    import("../yellow/week2/grammar/PresentSimpleContent"),

  // Week 2 Components - Listening
  "yellow/week2/listening/ListeningVocabularyContent": () =>
    import("../yellow/week2/listening/ListeningVocabularyContent"),
  "yellow/week2/listening/PastTenseStoriesContent": () =>
    import("../yellow/week2/listening/PastTenseStoriesContent"),

  // Week 2 Components - Reading
  "yellow/week2/reading/ReadingVocabularyContent": () =>
    import("../yellow/week2/reading/ReadingVocabularyContent"),
  "yellow/week2/reading/StoriesAndFablesContent": () =>
    import("../yellow/week2/reading/StoriesAndFablesContent"),

  // Week 2 Components - Review
  "yellow/week2/review/Week2ReviewContent": () =>
    import("../yellow/week2/review/Week2ReviewContent"),

  // Week 2 Components - Speaking
  "yellow/week2/speaking/NarratingStoriesContent": () =>
    import("../yellow/week2/speaking/NarratingStoriesContent"),
  "yellow/week2/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week2/speaking/SpeakingVocabularyContent"),

  // Week 2 Components - Vocabulary
  "yellow/week2/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week2/vocabulary/AcademicWordsContent"),

  // Week 2 Components - Writing
  "yellow/week2/writing/CompoundSentencesContent": () =>
    import("../yellow/week2/writing/CompoundSentencesContent"),
  "yellow/week2/writing/WritingMistakesContent": () =>
    import("../yellow/week2/writing/WritingMistakesContent"),

  // Week 3 Components - Grammar
  "yellow/week3/grammar/NounsContent": () =>
    import("../yellow/week3/grammar/NounsContent"),
  "yellow/week3/grammar/VerbsContent": () =>
    import("../yellow/week3/grammar/VerbsContent"),

  // Week 3 Components - Listening
  "yellow/week3/listening/ListeningVocabularyContent": () =>
    import("../yellow/week3/listening/ListeningVocabularyContent"),
  "yellow/week3/listening/ReviewsLikesDislikesContent": () =>
    import("../yellow/week3/listening/ReviewsLikesDislikesContent"),

  // Week 3 Components - Reading
  "yellow/week3/reading/ReadingReviewsContent": () =>
    import("../yellow/week3/reading/ReadingReviewsContent"),
  "yellow/week3/reading/ReadingVocabularyContent": () =>
    import("../yellow/week3/reading/ReadingVocabularyContent"),

  // Week 3 Components - Review
  "yellow/week3/review/Week3ReviewContent": () =>
    import("../yellow/week3/review/Week3ReviewContent"),

  // Week 3 Components - Speaking
  "yellow/week3/speaking/LikesDislikesContent": () =>
    import("../yellow/week3/speaking/LikesDislikesContent"),
  "yellow/week3/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week3/speaking/SpeakingVocabularyContent"),

  // Week 3 Components - Vocabulary
  "yellow/week3/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week3/vocabulary/AcademicWordsContent"),

  // Week 3 Components - Writing
  "yellow/week3/writing/ComplexSentencesContent": () =>
    import("../yellow/week3/writing/ComplexSentencesContent"),

  // Week 4 Components - Grammar
  "yellow/week4/grammar/ModalVerbsAbilityContent": () =>
    import("../yellow/week4/grammar/ModalVerbsAbilityContent"),
  "yellow/week4/grammar/ModalVerbsOverviewContent": () =>
    import("../yellow/week4/grammar/ModalVerbsOverviewContent"),

  // Week 4 Components - Listening
  "yellow/week4/listening/ListeningVocabularyContent": () =>
    import("../yellow/week4/listening/ListeningVocabularyContent"),
  "yellow/week4/listening/RequestsOffersContent": () =>
    import("../yellow/week4/listening/RequestsOffersContent"),

  // Week 4 Components - Reading
  "yellow/week4/reading/AcademicEmailsContent": () =>
    import("../yellow/week4/reading/AcademicEmailsContent"),
  "yellow/week4/reading/ReadingVocabularyContent": () =>
    import("../yellow/week4/reading/ReadingVocabularyContent"),

  // Week 4 Components - Review
  "yellow/week4/review/Week4ReviewContent": () =>
    import("../yellow/week4/review/Week4ReviewContent"),

  // Week 4 Components - Speaking
  "yellow/week4/speaking/MakingRequestsOffersContent": () =>
    import("../yellow/week4/speaking/MakingRequestsOffersContent"),
  "yellow/week4/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week4/speaking/SpeakingVocabularyContent"),

  // Week 4 Components - Vocabulary
  "yellow/week4/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week4/vocabulary/AcademicWordsContent"),

  // Week 4 Components - Writing
  "yellow/week4/writing/EmailWritingContent": () =>
    import("../yellow/week4/writing/EmailWritingContent"),

  // Week 5 Components - Grammar
  "yellow/week5/grammar/ActivePassiveContent": () =>
    import("../yellow/week5/grammar/ActivePassiveContent"),

  // Week 5 Components - Listening
  "yellow/week5/listening/FilterBubbleContent": () =>
    import("../yellow/week5/listening/FilterBubbleContent"),
  "yellow/week5/listening/ListeningVocabularyContent": () =>
    import("../yellow/week5/listening/ListeningVocabularyContent"),

  // Week 5 Components - Reading
  "yellow/week5/reading/ReadingTextbooksContent": () =>
    import("../yellow/week5/reading/ReadingTextbooksContent"),
  "yellow/week5/reading/ReadingVocabularyContent": () =>
    import("../yellow/week5/reading/ReadingVocabularyContent"),

  // Week 5 Components - Review
  "yellow/week5/review/Week5ReviewContent": () =>
    import("../yellow/week5/review/Week5ReviewContent"),

  // Week 5 Components - Speaking
  "yellow/week5/speaking/PronunciationContent": () =>
    import("../yellow/week5/speaking/PronunciationContent"),
  "yellow/week5/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week5/speaking/SpeakingVocabularyContent"),

  // Week 5 Components - Vocabulary
  "yellow/week5/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week5/vocabulary/AcademicWordsContent"),

  // Week 5 Components - Writing
  "yellow/week5/writing/PassiveVoiceContent": () =>
    import("../yellow/week5/writing/PassiveVoiceContent"),

  // Week 6 Components - Grammar
  "yellow/week6/grammar/PastContinuousContent": () =>
    import("../yellow/week6/grammar/PastContinuousContent"),

  // Week 6 Components - Listening
  "yellow/week6/listening/ListeningStrategiesContent": () =>
    import("../yellow/week6/listening/ListeningStrategiesContent"),
  "yellow/week6/listening/ListeningVocabularyContent": () =>
    import("../yellow/week6/listening/ListeningVocabularyContent"),

  // Week 6 Components - Reading
  "yellow/week6/reading/ReadingVocabularyContent": () =>
    import("../yellow/week6/reading/ReadingVocabularyContent"),
  "yellow/week6/reading/ReportsContent": () =>
    import("../yellow/week6/reading/ReportsContent"),

  // Week 6 Components - Review
  "yellow/week6/review/Week6ReviewContent": () =>
    import("../yellow/week6/review/Week6ReviewContent"),

  // Week 6 Components - Speaking
  "yellow/week6/speaking/PronunciationContent": () =>
    import("../yellow/week6/speaking/PronunciationContent"),
  "yellow/week6/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week6/speaking/SpeakingVocabularyContent"),

  // Week 6 Components - Vocabulary
  "yellow/week6/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week6/vocabulary/AcademicWordsContent"),

  // Week 6 Components - Writing
  "yellow/week6/writing/EditingContent": () =>
    import("../yellow/week6/writing/EditingContent"),

  // Week 7 Components - Grammar
  "yellow/week7/grammar/PresentPerfectContent": () =>
    import("../yellow/week7/grammar/PresentPerfectContent"),
  "yellow/week7/grammar/PresentPerfectWordsContent": () =>
    import("../yellow/week7/grammar/PresentPerfectWordsContent"),

  // Week 7 Components - Listening
  "yellow/week7/listening/ListeningDescriptionsContent": () =>
    import("../yellow/week7/listening/ListeningDescriptionsContent"),
  "yellow/week7/listening/ListeningVocabularyContent": () =>
    import("../yellow/week7/listening/ListeningVocabularyContent"),

  // Week 7 Components - Reading
  "yellow/week7/reading/ReadingVocabularyContent": () =>
    import("../yellow/week7/reading/ReadingVocabularyContent"),
  "yellow/week7/reading/ReportsExecutiveSummaryContent": () =>
    import("../yellow/week7/reading/ReportsExecutiveSummaryContent"),

  // Week 7 Components - Review
  "yellow/week7/review/Week7ReviewContent": () =>
    import("../yellow/week7/review/Week7ReviewContent"),

  // Week 7 Components - Speaking
  "yellow/week7/speaking/PhoneticAlphabetContent": () =>
    import("../yellow/week7/speaking/PhoneticAlphabetContent"),
  "yellow/week7/speaking/SchwaContent": () =>
    import("../yellow/week7/speaking/SchwaContent"),
  "yellow/week7/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week7/speaking/SpeakingVocabularyContent"),

  // Week 7 Components - Vocabulary
  "yellow/week7/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week7/vocabulary/AcademicWordsContent"),

  // Week 7 Components - Writing
  "yellow/week7/writing/ParagraphStructureContent": () =>
    import("../yellow/week7/writing/ParagraphStructureContent"),

  // Week 8 Components - Grammar
  "yellow/week8/grammar/FutureTenseContent": () =>
    import("../yellow/week8/grammar/FutureTenseContent"),

  // Week 8 Components - Listening
  "yellow/week8/listening/ListeningVocabularyContent": () =>
    import("../yellow/week8/listening/ListeningVocabularyContent"),
  "yellow/week8/listening/MapDiagramsContent": () =>
    import("../yellow/week8/listening/MapDiagramsContent"),

  // Week 8 Components - Reading
  "yellow/week8/reading/ReadingVocabularyContent": () =>
    import("../yellow/week8/reading/ReadingVocabularyContent"),
  "yellow/week8/reading/WritersPurposeContent": () =>
    import("../yellow/week8/reading/WritersPurposeContent"),

  // Week 8 Components - Review
  "yellow/week8/review/Week8ReviewContent": () =>
    import("../yellow/week8/review/Week8ReviewContent"),

  // Week 8 Components - Speaking
  "yellow/week8/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week8/speaking/SpeakingVocabularyContent"),
  "yellow/week8/speaking/WordStressContent": () =>
    import("../yellow/week8/speaking/WordStressContent"),

  // Week 8 Components - Vocabulary
  "yellow/week8/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week8/vocabulary/AcademicWordsContent"),

  // Week 8 Components - Writing
  "yellow/week8/writing/TopicSentencesContent": () =>
    import("../yellow/week8/writing/TopicSentencesContent"),

  // Week 9 Components - Grammar
  "yellow/week9/grammar/FutureTenseContent": () =>
    import("../yellow/week9/grammar/FutureTenseContent"),

  // Week 9 Components - Listening
  "yellow/week9/listening/ListeningVocabularyContent": () =>
    import("../yellow/week9/listening/ListeningVocabularyContent"),
  "yellow/week9/listening/TableListeningContent": () =>
    import("../yellow/week9/listening/TableListeningContent"),

  // Week 9 Components - Reading
  "yellow/week9/reading/MainIdeaContent": () =>
    import("../yellow/week9/reading/MainIdeaContent"),
  "yellow/week9/reading/ReadingVocabularyContent": () =>
    import("../yellow/week9/reading/ReadingVocabularyContent"),

  // Week 9 Components - Review
  "yellow/week9/review/Week9ReviewContent": () =>
    import("../yellow/week9/review/Week9ReviewContent"),

  // Week 9 Components - Speaking
  "yellow/week9/speaking/DiscussingBooksContent": () =>
    import("../yellow/week9/speaking/DiscussingBooksContent"),
  "yellow/week9/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week9/speaking/SpeakingVocabularyContent"),

  // Week 9 Components - Vocabulary
  "yellow/week9/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week9/vocabulary/AcademicWordsContent"),

  // Week 9 Components - Writing
  "yellow/week9/writing/SupportingSentencesContent": () =>
    import("../yellow/week9/writing/SupportingSentencesContent"),
  "yellow/week9/writing/TransitionSignalsContent": () =>
    import("../yellow/week9/writing/TransitionSignalsContent"),

  // Week 10 Components - Grammar
  "yellow/week10/grammar/ComparingContrastingContent": () =>
    import("../yellow/week10/grammar/ComparingContrastingContent"),

  // Week 10 Components - Listening
  "yellow/week10/listening/ListeningVocabularyContent": () =>
    import("../yellow/week10/listening/ListeningVocabularyContent"),
  "yellow/week10/listening/MultipleChoiceQuestionsContent": () =>
    import("../yellow/week10/listening/MultipleChoiceQuestionsContent"),

  // Week 10 Components - Reading
  "yellow/week10/reading/MultipleChoiceReadingContent": () =>
    import("../yellow/week10/reading/MultipleChoiceReadingContent"),
  "yellow/week10/reading/ReadingVocabularyContent": () =>
    import("../yellow/week10/reading/ReadingVocabularyContent"),

  // Week 10 Components - Review
  "yellow/week10/review/Week10ReviewContent": () =>
    import("../yellow/week10/review/Week10ReviewContent"),

  // Week 10 Components - Speaking
  "yellow/week10/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week10/speaking/SpeakingVocabularyContent"),
  "yellow/week10/speaking/TalkingAboutMoviesContent": () =>
    import("../yellow/week10/speaking/TalkingAboutMoviesContent"),

  // Week 10 Components - Vocabulary
  "yellow/week10/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week10/vocabulary/AcademicWordsContent"),

  // Week 10 Components - Writing
  "yellow/week10/writing/ConcludingSentencesContent": () =>
    import("../yellow/week10/writing/ConcludingSentencesContent"),
  "yellow/week10/writing/WritingVocabularyContent": () =>
    import("../yellow/week10/writing/WritingVocabularyContent"),

  // Week 11 Components - Grammar
  "yellow/week11/grammar/WordOrderContent": () =>
    import("../yellow/week11/grammar/WordOrderContent"),

  // Week 11 Components - Listening
  "yellow/week11/listening/ListeningVocabularyContent": () =>
    import("../yellow/week11/listening/ListeningVocabularyContent"),
  "yellow/week11/listening/MatchingQuestionsContent": () =>
    import("../yellow/week11/listening/MatchingQuestionsContent"),

  // Week 11 Components - Reading
  "yellow/week11/reading/ReadingVocabularyContent": () =>
    import("../yellow/week11/reading/ReadingVocabularyContent"),
  "yellow/week11/reading/SupportedDetailContent": () =>
    import("../yellow/week11/reading/SupportedDetailContent"),

  // Week 11 Components - Review
  "yellow/week11/review/Week11ReviewContent": () =>
    import("../yellow/week11/review/Week11ReviewContent"),

  // Week 11 Components - Speaking
  "yellow/week11/speaking/PoliteLanguageContent": () =>
    import("../yellow/week11/speaking/PoliteLanguageContent"),
  "yellow/week11/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week11/speaking/SpeakingVocabularyContent"),

  // Week 11 Components - Vocabulary
  "yellow/week11/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week11/vocabulary/AcademicWordsContent"),

  // Week 11 Components - Writing
  "yellow/week11/writing/EssayPartsContent": () =>
    import("../yellow/week11/writing/EssayPartsContent"),
  "yellow/week11/writing/EssayStructureContent": () =>
    import("../yellow/week11/writing/EssayStructureContent"),

  // Week 12 Components - Grammar
  "yellow/week12/grammar/WordFormsContent": () =>
    import("../yellow/week12/grammar/WordFormsContent"),

  // Week 12 Components - Listening
  "yellow/week12/listening/ListeningVocabularyContent": () =>
    import("../yellow/week12/listening/ListeningVocabularyContent"),
  "yellow/week12/listening/SentenceCompletionContent": () =>
    import("../yellow/week12/listening/SentenceCompletionContent"),

  // Week 12 Components - Reading
  "yellow/week12/reading/CornellNotesContent": () =>
    import("../yellow/week12/reading/CornellNotesContent"),
  "yellow/week12/reading/ReadingOutlinesContent": () =>
    import("../yellow/week12/reading/ReadingOutlinesContent"),
  "yellow/week12/reading/ReadingVocabularyContent": () =>
    import("../yellow/week12/reading/ReadingVocabularyContent"),

  // Week 12 Components - Review
  "yellow/week12/review/Week12ReviewContent": () =>
    import("../yellow/week12/review/Week12ReviewContent"),

  // Week 12 Components - Speaking
  "yellow/week12/speaking/CauseEffectSpeakingContent": () =>
    import("../yellow/week12/speaking/CauseEffectSpeakingContent"),

  // Week 12 Components - Vocabulary
  "yellow/week12/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week12/vocabulary/AcademicWordsContent"),

  // Week 12 Components - Writing
  "yellow/week12/writing/IntroductionsContent": () =>
    import("../yellow/week12/writing/IntroductionsContent"),
  "yellow/week12/writing/ThesisStatementsContent": () =>
    import("../yellow/week12/writing/ThesisStatementsContent"),

  // Week 13 Components - Grammar
  "yellow/week13/grammar/ConjunctionsContent": () =>
    import("../yellow/week13/grammar/ConjunctionsContent"),

  // Week 13 Components - Listening
  "yellow/week13/listening/ListeningApproachContent": () =>
    import("../yellow/week13/listening/ListeningApproachContent"),
  "yellow/week13/listening/ListeningVocabularyContent": () =>
    import("../yellow/week13/listening/ListeningVocabularyContent"),

  // Week 13 Components - Reading
  "yellow/week13/reading/ReadingVocabularyContent": () =>
    import("../yellow/week13/reading/ReadingVocabularyContent"),
  "yellow/week13/reading/SkimmingScanningContent": () =>
    import("../yellow/week13/reading/SkimmingScanningContent"),

  // Week 13 Components - Review
  "yellow/week13/review/Week13ReviewContent": () =>
    import("../yellow/week13/review/Week13ReviewContent"),

  // Week 13 Components - Speaking
  "yellow/week13/speaking/DiscussionLanguageContent": () =>
    import("../yellow/week13/speaking/DiscussionLanguageContent"),

  // Week 13 Components - Vocabulary
  "yellow/week13/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week13/vocabulary/AcademicWordsContent"),

  // Week 13 Components - Writing
  "yellow/week13/writing/BodyParagraphsContent": () =>
    import("../yellow/week13/writing/BodyParagraphsContent"),
  "yellow/week13/writing/WritingVocabularyContent": () =>
    import("../yellow/week13/writing/WritingVocabularyContent"),

  // Week 14 Components - Grammar
  "yellow/week14/grammar/PronounsContent": () =>
    import("../yellow/week14/grammar/PronounsContent"),

  // Week 14 Components - Listening
  "yellow/week14/listening/AbbreviationsSymbolsContent": () =>
    import("../yellow/week14/listening/AbbreviationsSymbolsContent"),
  "yellow/week14/listening/ListeningVocabularyContent": () =>
    import("../yellow/week14/listening/ListeningVocabularyContent"),
  "yellow/week14/listening/NoteTakingIntroContent": () =>
    import("../yellow/week14/listening/NoteTakingIntroContent"),

  // Week 14 Components - Reading
  "yellow/week14/reading/ParaphrasingIntroContent": () =>
    import("../yellow/week14/reading/ParaphrasingIntroContent"),
  "yellow/week14/reading/ParaphrasingMethodsContent": () =>
    import("../yellow/week14/reading/ParaphrasingMethodsContent"),
  "yellow/week14/reading/ReadingVocabularyContent": () =>
    import("../yellow/week14/reading/ReadingVocabularyContent"),

  // Week 14 Components - Review
  "yellow/week14/review/Week14ReviewContent": () =>
    import("../yellow/week14/review/Week14ReviewContent"),

  // Week 14 Components - Speaking
  "yellow/week14/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week14/speaking/SpeakingVocabularyContent"),

  // Week 14 Components - Vocabulary
  "yellow/week14/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week14/vocabulary/AcademicWordsContent"),

  // Week 14 Components - Writing
  "yellow/week14/writing/CohesionIntroContent": () =>
    import("../yellow/week14/writing/CohesionIntroContent"),
  "yellow/week14/writing/RepeatingKeyWordsContent": () =>
    import("../yellow/week14/writing/RepeatingKeyWordsContent"),
  "yellow/week14/writing/TransitionSignalsContent": () =>
    import("../yellow/week14/writing/TransitionSignalsContent"),

  // Week 15 Components - Grammar
  "yellow/week15/grammar/SubordinateClausesContent": () =>
    import("../yellow/week15/grammar/SubordinateClausesContent"),

  // Week 15 Components - Listening
  "yellow/week15/listening/LectureIntroductionsContent": () =>
    import("../yellow/week15/listening/LectureIntroductionsContent"),
  "yellow/week15/listening/ListeningVocabularyContent": () =>
    import("../yellow/week15/listening/ListeningVocabularyContent"),

  // Week 15 Components - Reading
  "yellow/week15/reading/ReadingVocabularyContent": () =>
    import("../yellow/week15/reading/ReadingVocabularyContent"),
  "yellow/week15/reading/RecognisingSummariesContent": () =>
    import("../yellow/week15/reading/RecognisingSummariesContent"),

  // Week 15 Components - Review
  "yellow/week15/review/Week15ReviewContent": () =>
    import("../yellow/week15/review/Week15ReviewContent"),

  // Week 15 Components - Speaking
  "yellow/week15/speaking/PreparingPresentationsContent": () =>
    import("../yellow/week15/speaking/PreparingPresentationsContent"),
  "yellow/week15/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week15/speaking/SpeakingVocabularyContent"),

  // Week 15 Components - Vocabulary
  "yellow/week15/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week15/vocabulary/AcademicWordsContent"),

  // Week 15 Components - Writing
  "yellow/week15/writing/ConclusionsContent": () =>
    import("../yellow/week15/writing/ConclusionsContent"),

  // Week 16 Components - Grammar
  "yellow/week16/grammar/ComplementClausesContent": () =>
    import("../yellow/week16/grammar/ComplementClausesContent"),

  // Week 16 Components - Listening
  "yellow/week16/listening/LectureOrganisationContent": () =>
    import("../yellow/week16/listening/LectureOrganisationContent"),
  "yellow/week16/listening/ListeningVocabularyContent": () =>
    import("../yellow/week16/listening/ListeningVocabularyContent"),

  // Week 16 Components - Reading
  "yellow/week16/reading/ReadingVocabularyContent": () =>
    import("../yellow/week16/reading/ReadingVocabularyContent"),
  "yellow/week16/reading/ReferenceFormsContent": () =>
    import("../yellow/week16/reading/ReferenceFormsContent"),

  // Week 16 Components - Review
  "yellow/week16/review/Week16ReviewContent": () =>
    import("../yellow/week16/review/Week16ReviewContent"),

  // Week 16 Components - Speaking
  "yellow/week16/speaking/PresentationSkillsContent": () =>
    import("../yellow/week16/speaking/PresentationSkillsContent"),
  "yellow/week16/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week16/speaking/SpeakingVocabularyContent"),

  // Week 16 Components - Vocabulary
  "yellow/week16/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week16/vocabulary/AcademicWordsContent"),

  // Week 16 Components - Writing
  "yellow/week16/writing/InTextReferencingContent": () =>
    import("../yellow/week16/writing/InTextReferencingContent"),
  "yellow/week16/writing/WritingVocabularyContent": () =>
    import("../yellow/week16/writing/WritingVocabularyContent"),

  // Week 17 Components - Grammar
  "yellow/week17/grammar/ParticiplesContent": () =>
    import("../yellow/week17/grammar/ParticiplesContent"),

  // Week 17 Components - Listening
  "yellow/week17/listening/ListeningVocabularyContent": () =>
    import("../yellow/week17/listening/ListeningVocabularyContent"),
  "yellow/week17/listening/SignalsInLecturesContent": () =>
    import("../yellow/week17/listening/SignalsInLecturesContent"),
  "yellow/week17/listening/TimeManagementLectureContent": () =>
    import("../yellow/week17/listening/TimeManagementLectureContent"),

  // Week 17 Components - Reading
  "yellow/week17/reading/FactsAndOpinionsContent": () =>
    import("../yellow/week17/reading/FactsAndOpinionsContent"),
  "yellow/week17/reading/ReadingVocabularyContent": () =>
    import("../yellow/week17/reading/ReadingVocabularyContent"),

  // Week 17 Components - Review
  "yellow/week17/review/Week17ReviewContent": () =>
    import("../yellow/week17/review/Week17ReviewContent"),

  // Week 17 Components - Speaking
  "yellow/week17/speaking/QASpeakingContent": () =>
    import("../yellow/week17/speaking/QASpeakingContent"),

  // Week 17 Components - Vocabulary
  "yellow/week17/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week17/vocabulary/AcademicWordsContent"),

  // Week 17 Components - Writing
  "yellow/week17/writing/ReferenceListsContent": () =>
    import("../yellow/week17/writing/ReferenceListsContent"),
  "yellow/week17/writing/WritingVocabularyContent": () =>
    import("../yellow/week17/writing/WritingVocabularyContent"),

  // Week 18 Components - Grammar
  "yellow/week18/grammar/NounPhrasesContent": () =>
    import("../yellow/week18/grammar/NounPhrasesContent"),

  // Week 18 Components - Listening
  "yellow/week18/listening/ListeningVocabularyContent": () =>
    import("../yellow/week18/listening/ListeningVocabularyContent"),
  "yellow/week18/listening/NoteAbbreviationsContent": () =>
    import("../yellow/week18/listening/NoteAbbreviationsContent"),

  // Week 18 Components - Reading
  "yellow/week18/reading/BiasedTextsContent": () =>
    import("../yellow/week18/reading/BiasedTextsContent"),
  "yellow/week18/reading/ReadingVocabularyContent": () =>
    import("../yellow/week18/reading/ReadingVocabularyContent"),

  // Week 18 Components - Review
  "yellow/week18/review/Week18ReviewContent": () =>
    import("../yellow/week18/review/Week18ReviewContent"),

  // Week 18 Components - Speaking
  "yellow/week18/speaking/ChairingDiscussionsContent": () =>
    import("../yellow/week18/speaking/ChairingDiscussionsContent"),
  "yellow/week18/speaking/SpeakingVocabularyContent": () =>
    import("../yellow/week18/speaking/SpeakingVocabularyContent"),

  // Week 18 Components - Vocabulary
  "yellow/week18/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week18/vocabulary/AcademicWordsContent"),

  // Week 18 Components - Writing
  "yellow/week18/writing/RelativeClausesContent": () =>
    import("../yellow/week18/writing/RelativeClausesContent"),
  "yellow/week18/writing/WritingVocabularyContent": () =>
    import("../yellow/week18/writing/WritingVocabularyContent"),

  // Week 19 Components - Grammar
  "yellow/week19/grammar/PrepositionalPhrasesContent": () =>
    import("../yellow/week19/grammar/PrepositionalPhrasesContent"),

  // Week 19 Components - Listening
  "yellow/week19/listening/LectureConclusionsContent": () =>
    import("../yellow/week19/listening/LectureConclusionsContent"),
  "yellow/week19/listening/ListeningVocabularyContent": () =>
    import("../yellow/week19/listening/ListeningVocabularyContent"),

  // Week 19 Components - Reading
  "yellow/week19/reading/ReadingStrategiesContent": () =>
    import("../yellow/week19/reading/ReadingStrategiesContent"),
  "yellow/week19/reading/ReadingVocabularyContent": () =>
    import("../yellow/week19/reading/ReadingVocabularyContent"),

  // Week 19 Components - Review
  "yellow/week19/review/Week19ReviewContent": () =>
    import("../yellow/week19/review/Week19ReviewContent"),

  // Week 19 Components - Speaking
  "yellow/week19/speaking/PeerFeedbackContent": () =>
    import("../yellow/week19/speaking/PeerFeedbackContent"),

  // Week 19 Components - Vocabulary
  "yellow/week19/vocabulary/AcademicWordsContent": () =>
    import("../yellow/week19/vocabulary/AcademicWordsContent"),

  // Week 19 Components - Writing
  "yellow/week19/writing/CommonErrorsContent": () =>
    import("../yellow/week19/writing/CommonErrorsContent"),
  "yellow/week19/writing/EditingWritingContent": () =>
    import("../yellow/week19/writing/EditingWritingContent"),

  // Week 20 Components - Grammar
  "yellow/week20/grammar/GrammarReviewContent": () =>
    import("../yellow/week20/grammar/GrammarReviewContent"),

  // Week 20 Components - Listening
  "yellow/week20/listening/ListeningStrategiesReviewContent": () =>
    import("../yellow/week20/listening/ListeningStrategiesReviewContent"),

  // Week 20 Components - Reading
  "yellow/week20/reading/ReadingSkillsReviewContent": () =>
    import("../yellow/week20/reading/ReadingSkillsReviewContent"),

  // Week 20 Components - Review
  "yellow/week20/review/Week20ReviewContent": () =>
    import("../yellow/week20/review/Week20ReviewContent"),

  // Week 20 Components - Speaking
  "yellow/week20/speaking/SpeakingReviewContent": () =>
    import("../yellow/week20/speaking/SpeakingReviewContent"),

  // Week 20 Components - Vocabulary
  "yellow/week20/vocabulary/VocabularyReviewContent": () =>
    import("../yellow/week20/vocabulary/VocabularyReviewContent"),

  // Week 20 Components - Writing
  "yellow/week20/writing/ParagraphEssayReviewContent": () =>
    import("../yellow/week20/writing/ParagraphEssayReviewContent"),
  "yellow/week20/writing/SentenceStructuresReviewContent": () =>
    import("../yellow/week20/writing/SentenceStructuresReviewContent"),
} as const;
